import React, { InputHTMLAttributes, useRef } from 'react';

interface RadioButtonProps extends InputHTMLAttributes<HTMLInputElement> {
    label: string,
}

const RadioButton = (props: RadioButtonProps) => {
    const { label, ...nativeProps } = props;

    const radioRef = useRef<HTMLInputElement>(null);

    const handleLabelClick = () => {
        if (radioRef.current) {
            radioRef.current.click();
        }
    };
    return (
        <>
            <div className="flex gap-1 items-center cursor-pointer" onClick={() => { handleLabelClick() }}>
                <input type="radio" ref={radioRef} className="radio" {...nativeProps} />
                <label className='cursor-pointer' >{label}</label>
            </div>
        </>
    );
};

export default RadioButton;